export default {
    page_title: 'Medical Records Upload Portal',
    header: {
        secure_portal: 'Secure Provider Portal',
        encrypted_256: '256-bit encrypted',
    },
    stepper: {
        verify: 'VERIFY',
        account: 'ACCOUNT',
        review: 'REVIEW',
        upload: 'UPLOAD',
        confirm: 'CONFIRM',
    },
    footer: {
        copyright: '© {year} Medmatch Network. HIPAA-compliant platform.',
        secure_connection: 'Secure Connection',
    },
    step_verify: {
        title: 'Secure Record Upload Request',
        subtitle:
            'You have received a medical records request through the Medmatch Network. Enter the access code from your email to proceed securely.',
        link_expires_on: 'This secure link expires on',
        security_warning: 'Do not share this link. All access is logged.',
        code_label: 'Enter the 4-character access code from your email',
        code_hint: 'Code from email subject:',
        overview_title: 'Request overview:',
        patient_label: 'Patient:',
        due_label: 'Due:',
        records_label: 'Records:',
        verifying: 'Verifying...',
        verify_continue: 'Verify & Continue',
        support_prompt: 'Having trouble? Call Medmatch Network support:',
    },
    step_account: {
        title: 'How would you like to continue?',
        subtitle:
            'A Medmatch Network account lets you track all record requests, get notifications, and keep an audit trail — for free.',
        guest_title: 'Continue as Guest',
        guest_desc: 'One-time upload — no account needed',
        recommended_badge: 'RECOMMENDED',
        create_account_title: 'Create Free Account',
        create_account_desc: 'Track requests & audit log',
        signin_title: 'Sign In',
        signin_desc: 'Already have an account',
        full_name_label: 'Full name',
        full_name_placeholder: 'Dr. Jane Smith',
        org_label: 'Organization / Facility',
        org_placeholder: "St. Mary's Hospital",
        work_email_label: 'Work email',
        email_placeholder: 'you@hospital.com',
        password_label: 'Password',
        password_placeholder: 'Min. 8 characters',
        terms_prefix: "By creating an account you agree to Medmatch Network's",
        terms_of_service: 'Terms of Service',
        and: 'and',
        privacy_policy: 'Privacy Policy',
        back_to_options: 'Back to options',
        email_label: 'Email',
        signin_password_placeholder: 'Your password',
        forgot_password: 'Forgot password?',
        guest_info_prefix: 'You are continuing as a',
        guest_highlight: 'guest',
        guest_info_suffix: 'A transmission receipt will be emailed to you after upload. No account will be created.',
        guest_email_label: 'Your email (for receipt)',
        select_option_continue: 'Select an option to continue',
        create_and_continue: 'Create Account & Continue',
        signin_and_continue: 'Sign In & Continue',
        forgot_password_toast: 'Please check your email for password reset instructions.',
    },
    step_review: {
        title: 'Request Details',
        urgent_badge: 'urgent',
        requesting_provider: 'Requesting Provider',
        npi_prefix: 'NPI: {npi}',
        patient_identity: 'Patient Identity',
        full_name: 'Full Name',
        dob: 'Date of Birth',
        ssn_last4: 'SSN (last 4)',
        records_requested: 'Records Requested',
        date_range_label: 'Date range:',
        purpose_label: 'Purpose:',
        authorization: 'Authorization',
        hipaa_attached: 'HIPAA Authorization attached',
        hipaa_sub: 'Signed by patient · Valid through Jan 15, 2026 · Scope: Complete medical records',
        view_pdf: 'View PDF',
        access_granted_prefix: 'Access granted via token',
        access_granted_suffix: 'All access is logged and timestamped for audit compliance.',
        response_requested_by: 'Response requested by',
        proceed_upload: 'Proceed to Upload Records',
    },
    step_upload: {
        title: 'Upload Records',
        uploading_for: 'Uploading for:',
        request_label: 'Request',
        drop_main: 'Drop files here or click to browse',
        drop_sub: 'PDF, TIFF, DICOM, PNG, JPG — up to 200 MB per file',
        files_selected_count: '{count} FILE SELECTED | {count} FILES SELECTED',
        note_label: 'Note to requesting provider',
        optional: '(optional)',
        note_placeholder:
            'e.g., Attached are all records within the requested date range. Records prior to 2022 are not in our EHR system...',
        encryption_notice:
            'Files are encrypted in transit and at rest. Only the requesting provider can access them. A transmission receipt will be emailed to you upon successful upload.',
        submitting: 'Submitting Records...',
        submit_securely: 'Submit Records Securely',
        remove_file: 'Remove file',
    },
    step_confirm: {
        title: 'Records Submitted',
        subtitle: 'Your records have been securely delivered to the Medmatch Network platform.',
        request_id: 'Request ID',
        files_uploaded: 'Files Uploaded',
        sent_to: 'Sent To',
        submitted_at: 'Submitted At',
        files_delivered: 'Files delivered',
        receipt_notice:
            'A transmission receipt has been sent to your email address. Please keep it for your records. This upload link is now expired.',
        return_dashboard: 'Return to EHR Dashboard',
        files_count: '{count} file | {count} files',
    },
    categories: {
        complete_medical_history: 'Complete Medical History',
        prescription_history: 'Prescription History',
        lab_results: 'Lab Results',
        surgical_records: 'Surgical Records',
        imaging_reports: 'Imaging Reports',
        immunization_records: 'Immunization Records',
        consultation_notes: 'Consultation Notes',
        mental_health_records: 'Mental Health Records',
        other: 'Other',
    },
}
